import axios from "axios";
const baseURL = "/api";
axios.defaults.baseURL = baseURL;

//轮播广告
export const adbanner = params => {
  return axios
    .post(`/course/manage/proscenium/adbanner/query/list`, params)
    .then(res => res.data);
};
//登录接口
export const loginAccount = params => {
  return axios.post(`/uc/login/account`, params).then(res => res.data);
};
//验证码接口登录
export const loginverifycode = params => {
  return axios.post(`/uc/login/phone/verifycode`, params).then(res => res.data);
};
//发送验证码登录
export const verifycode = params => {
  return axios
    .post(`/uc/login/send/phone/verifycode`, params)
    .then(res => res.data);
};
//注册接口
export const register = params => {
  return axios.post(`/uc/register`, params).then(res => res.data);
};
//我的机构学院
export const myorg = params => {
  return axios.post(`/course/manage/org/myorg`, params).then(res => res.data);
};
//切换机构
export const changeorg = params => {
  return axios.post(`/uc/identify/org/change`, params).then(res => res.data);
};
//我的班级
export const myclass = params => {
  return axios
    .post(`/course/manage/homepage/myclass`, params)
    .then(res => res.data);
};
//创建学院
export const addorg = params => {
  return axios.post(`/course/manage/org/add`, params).then(res => res.data);
};
//上传图片接口
export const uploadimage = params => {
  return axios
    .post(`/third/api/huaWeiUpload/upload/image`, params)
    .then(res => res.data);
};
//学院主体信息接口
export const addtenant = params => {
  return axios
    .post(`/course/manage/org/tenant/add`, params)
    .then(res => res.data);
};
//加入学院邀请码
export const invitecode = params => {
  return axios
    .post(`/course/manage/org/join/invitecode`, params)
    .then(res => res.data);
};
//学院公告
export const actionList = params => {
  return axios
    .post(`/course/manage/announcement/query/list`, params)
    .then(res => res.data);
};
//学院动态
export const dynamicList = params => {
  return axios
    .post(`/course/manage/homepage/org/dynamic/query`, params)
    .then(res => res.data);
};
//用户信息
export const baseinfo = params => {
  return axios.get(`/uc/identify/user/baseinfo`, params).then(res => res.data);
};
export const updateAnnoPageviews = params => {
  return axios
    .post(`/course/manage/announcement/update/pageviews`, params)
    .then(res => res.data);
};
//权限查询
export const userAuthQuery = params => {
  return axios.post(`/course/manage/auth/query`, params).then(res => res.data);
};
//实名认证
export const userRealAuth = params => {
  return axios
    .post(`/course/manage/auth/real/name/auth`, params)
    .then(res => res.data);
};
//课程商城分类
export const courseCategory = params => {
  return axios
    .post(`/course/intro/product-category/list`, params)
    .then(res => res.data);
};
//课程商城列表
export const courseList = params => {
  return axios.post(`/course/intro/product/list`, params).then(res => res.data);
};
//课程详情
export const courseInfo = params => {
  return axios.post(`/course/intro/product/info`, params).then(res => res.data);
};
//新视频接口
export const getVideoPlayinfo = params => {
  return axios.post(`/course/video/play/info`, params).then(res => res.data);
};
//查询商品所在分类的所有上级分类
export const categoryinfo = params => {
  return axios
    .post(`/course/product/category/chain`, params)
    .then(res => res.data);
};
//推荐商品
export const productrecommond = params => {
  return axios
    .post(`/course/intro/product/recommond`, params)
    .then(res => res.data);
};
//待开始考试(班级)
export const examTodoList = params => {
  return axios
    .post(`/course/manage/exam/mine/todo/list`, params)
    .then(res => res.data);
};
//待开始考试(课程)
export const examCourseTodoList = params => {
  return axios
    .post(`course/manage/exam/course/todo/list`, params)
    .then(res => res.data);
};
//已开始考试
export const examRecord = params => {
  return axios
    .post(`/course/manage/exam/mine/record`, params)
    .then(res => res.data);
};
//考试初始化
export const examinit = params => {
  return axios.post(`/course/manage/exam/init`, params).then(res => res.data);
};
//渲染考生信息
export const examUserinfo = params => {
  return axios
    .post(`/course/manage/exam/query/examinfo/item/list`, params)
    .then(res => res.data);
};
//提交考生信息
export const examSubmit = params => {
  return axios
    .post(`/course/manage/exam/submit/examinfo`, params)
    .then(res => res.data);
};
//考试开始
export const examStart = params => {
  return axios.post(`/course/manage/exam/start`, params).then(res => res.data);
};
//考试详情
export const examquery = params => {
  return axios
    .post(`/course/manage/exam/query/detail`, params)
    .then(res => res.data);
};
//考题开始
export const examanswerStart = params => {
  return axios
    .post(`/course/manage/exam/answer/start`, params)
    .then(res => res.data);
};
//考题答题
export const examAnswer = params => {
  return axios.post(`/course/manage/exam/answer`, params).then(res => res.data);
};
//交卷
export const examAnswerSubmit = params => {
  return axios.post(`/course/manage/exam/submit`, params).then(res => res.data);
};
//考试结果
export const examresult = params => {
  return axios
    .post(`/course/manage/exam/query/result`, params)
    .then(res => res.data);
};
//考试成绩排行榜
export const examresultranklist = params => {
  return axios
    .post(`/course/manage/exam/score/rank/list`, params)
    .then(res => res.data);
};
//企业端分页查询测评试题
export const evalPage = params => {
  return axios
    .post(`/eval/identify/org/eval/page`, params)
    .then(res => res.data);
};
//企业端分页查询我的测评试题
export const myEval = params => {
  return axios
    .post(`/eval/identify/org/eval/myEval`, params)
    .then(res => res.data);
};
//查询行业
export const industryList = params => {
  return axios
    .post(`/eval/identify/org/eval/industryList`, params)
    .then(res => res.data);
};
//查询专业
export const majorList = params => {
  return axios
    .post(`/eval/identify/org/eval/majorList`, params)
    .then(res => res.data);
};
//记录学生数据信息并返回试卷id
export const examineeSave = params => {
  return axios
    .post(`/eval/identify/org/examinee/save`, params)
    .then(res => res.data);
};
//获取试题信息集合
export const getQuestionsList = params => {
  return axios
    .post(`/eval/identify/org/eval/getQuestions`, params)
    .then(res => res.data);
};
//获取测评头部信息
export const getEvalHeadInfo = params => {
  return axios
    .post(`/eval/identify/org/eval/getEvalHead`, params)
    .then(res => res.data);
};
//答题信息提交
export const commitEval = params => {
  return axios
    .post(`/eval/identify/org/eval/commitEval`, params)
    .then(res => res.data);
};
//查询我的测评结果
export const evalResult = params => {
  return axios
    .post(`/eval/identify/org/eval/evalResult`, params)
    .then(res => res.data);
};
//查询我的测评结果详情
export const evalResultDetail = params => {
  return axios
    .post(`/eval/identify/org/eval/evalResultDetail`, params)
    .then(res => res.data);
};

//查看企业是否认证
export const orgTenant = params => {
  return axios.post(`/course/manage/org/tenant`, params).then(res => res.data);
};
//首页公开课
export const publicCourse = params => {
  return axios
    .post(`/course/user/openCourse/page`, params)
    .then(res => res.data);
};
export const publicCourseInfo = params => {
  return axios
    .post(`/course/manage/homepage/open/course/detail`, params)
    .then(res => res.data);
};
export const publicCoursePlayDetail = params => {
  return axios
    .post(`/course/manage/homepage/open/course/play/detail`, params)
    .then(res => res.data);
};
export const statisticsBaseInfo = params => {
  return axios
    .post(`/course/manage/statistics/baseInfo`, params)
    .then(res => res.data);
};
export const statisticsStudyHistory = params => {
  return axios
    .post(`/course/manage/statistics/studyHistory`, params)
    .then(res => res.data);
};
export const statisticsCourseRank = params => {
  return axios
    .post(`/course/manage/statistics/finish/course/rank`, params)
    .then(res => res.data);
};
export const statisticsCreditRank = params => {
  return axios
    .post(`/course/manage/statistics/credit/rank`, params)
    .then(res => res.data);
};
export const statisticsDurationRank = params => {
  return axios
    .post(`/course/manage/statistics/study/duration/rank`, params)
    .then(res => res.data);
};
export const statisticsCharts = params => {
  return axios
    .post(`/course/manage/statistics/info`, params)
    .then(res => res.data);
};
export const userIsAdmin = params => {
  return axios
    .post(`/course/manage/auth/query`, params)
    .then(res => res.data);
};
//添加商品进购物车
export const shopcartAdd = params => {
  return axios.post(`/course/manage/shopcart/product/add`, params).then(res => res.data);
};
//购物车商品列表
export const shopcartList = params => {
  return axios.post(`/course/manage/shopcart/list`, params).then(res => res.data);
};
//批量清空购物车商品
export const shopcartRemoveMany = params => {
  return axios.post(`/course/manage/shopcart/products/remove`, params).then(res => res.data);
};
//清空失效商品
export const shopcartClear = params => {
  return axios.post(`/course/manage/shopcart/clear`, params).then(res => res.data);
};
//编辑商品
export const shopcartProductUpdate = params => {
  return axios.post(`/course/manage/shopcart/product/update`, params).then(res => res.data);
};
//统计商品
export const shopcartProductTotalPrice = params => {
  return axios.post(`/course/manage/shopcart/settle/queryPrice`, params).then(res => res.data);
};
//想学
export const CourseWantLearn = params => {
  return axios.post(`/course/manage/want/learn/create`, params).then(res => res.data);
};
//去结算接口
export const CoursebuyCommodity = params => {
  return axios.post(`/order/identify/orgOrder/enterprise/buyCommodity`, params).then(res => res.data);
};
//查询账户余额
export const useraccountMoney = params => {
  return axios.post(`/order/identify/amount/show`, params).then(res => res.data);
};
//余额支付
export const useraccountPayfor = params => {
  return axios.post(`/order/identify/orgOrder/enterprise/balancePay`, params).then(res => res.data);
};
//订单金额
export const orderBuyMoney = params => {
  return axios.post(`/order/identify/orgOrder/enterprise/buyCalcCommodity`, params).then(res => res.data);
};


// WEBPACK FOOTER //
// ./src/api/Apis.js